import { t } from '@localization/i18n';
import { LayoutDTO } from '@model/layout/LayoutDTO';
import { SelectOption } from '@/type';

// an empty layout (no elements) is marked, a slide on it would show nothing - still selectable
export const mapLayoutsToSelectOptions = (layouts: LayoutDTO[]): SelectOption[] =>
  (layouts ?? []).map(({ id, name, empty }) => ({
    value: id,
    label: empty ? `${name} (${t('layout.empty')})` : name,
  }));

export const mapToSelectOptions = <T extends { id?: number | string; name?: string }>(
  items: T[],
): SelectOption[] =>
  (items ?? []).map(({ id, name }) => ({
    value: id,
    label: name,
  }));
